module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-roll/408/assets/fonts/5309dec468cc53cee3b01e43c8e8d65d.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/styles/fonts/icomoon.ttf?qmfery
// module id = 1291
// module chunks = 3